module.exports = __webpack_public_path__ + "media/images/heart_hand-e31791d717f7b39c865f12c683ccebca.svg";